import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Seo } from "@/components/site/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (["owner", "admin", "staff"].includes(user.role)) navigate("/admin");
      else navigate("/portal");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-ivory">
      <Seo title="Staff Login | Psalm 30:2 Chiropractic" />
      <div className="hidden lg:block relative bg-espresso">
        <div className="absolute inset-0 bg-cover bg-center opacity-60 kenburns" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1773924093206-9a433a14bb44?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400)" }} />
        <div className="absolute inset-0 bg-espresso/50" />
        <div className="relative h-full flex flex-col justify-end p-16 text-ivory">
          <div className="font-serif text-5xl leading-tight">Psalm 30:2</div>
          <div className="text-xs uppercase tracking-[0.3em] mt-3 text-ivory/60">Content Portal</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="overline mb-4">Welcome back</div>
          <h1 className="font-serif font-light text-4xl text-espresso mb-8">Sign in</h1>
          {error && <div className="mb-5 text-sm text-destructive bg-destructive/5 border border-destructive/20 rounded-sm px-4 py-3" data-testid="login-error">{error}</div>}
          <label className="block text-xs uppercase tracking-[0.15em] text-taupe mb-2">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full bg-ivory border border-espresso/20 rounded-md px-4 py-3 mb-5 focus:outline-none focus:ring-2 focus:ring-brass" />
          <label className="block text-xs uppercase tracking-[0.15em] text-taupe mb-2">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full bg-ivory border border-espresso/20 rounded-md px-4 py-3 mb-8 focus:outline-none focus:ring-2 focus:ring-brass" />
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full bg-espresso text-ivory py-3.5 rounded-full text-xs uppercase tracking-[0.2em] hover:bg-espressosoft transition-all disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
